module.exports = __webpack_public_path__ + "static/media/3.a8fdfa19.jpg";